import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ChristmasService } from 'src/app/services/christmas.service';

@Component({
  selector: 'app-usuario-sem-modulos',
  templateUrl: './usuario-sem-modulos.component.html',
  styleUrls: ['./usuario-sem-modulos.component.css']
})
export class UsuarioSemModulosComponent implements OnInit {

  isChristmasMode: boolean = false;

  constructor(
    private router: Router,
    private snackBar: SnackBarService,
    private christmasService: ChristmasService
  ) { }

  ngOnInit() {
    this.isChristmasMode = this.christmasService.isChristmasMode();
  }

  voltarLogin() {
    this.router.navigateByUrl('/');
  }

  contatarAdministrador() {
    this.snackBar.showSnackBarInfo('Entre em contato com o administrador do sistema.');
  }
}
